import React, { useState } from 'react';
import axios from 'axios';
import { EnvelopeSimple, CheckCircle, PaperPlaneTilt } from '@phosphor-icons/react';
import { useWorkerLang } from '../../contexts/WorkerLanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const NewsletterSignup = () => {
  const { lang } = useWorkerLang();
  const L = (en, es) => (lang === 'es' ? es : en);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | done | error
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    setError('');
    try {
      await axios.post(`${BACKEND_URL}/api/newsletter/subscribe`, { email: email.trim(), source: 'landing' });
      setStatus('done');
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.detail || L('Something went wrong — try again', 'Algo salió mal — intenta de nuevo'));
    }
  };

  return (
    <div className="bg-[#D95800] py-14 border-y-2 border-black" data-testid="newsletter-section">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <div className="inline-flex items-center gap-2 bg-black text-white text-[10px] font-black uppercase tracking-widest px-3 py-1 mb-4">
          <EnvelopeSimple size={14} weight="bold" /> {L('Newsletter', 'Boletín')}
        </div>
        <h2 className="text-2xl md:text-3xl font-black text-white uppercase tracking-tight mb-2">
          {L('Build Smarter. Get the Newsletter.', 'Construye Mejor. Recibe el Boletín.')}
        </h2>
        <p className="text-white/85 mb-6 text-sm md:text-base">
          {L('Practical tips, new tools, and local market insights for contractors, workers, and homeowners — once a month, no spam.',
             'Consejos prácticos, nuevas herramientas y datos del mercado local para contratistas, trabajadores y propietarios — una vez al mes, sin spam.')}
        </p>

        {status === 'done' ? (
          <div className="inline-flex items-center gap-2 bg-white text-emerald-700 font-black uppercase px-6 py-4 border-2 border-black shadow-[4px_4px_0px_#000]" data-testid="newsletter-success">
            <CheckCircle size={22} weight="fill" />
            {L("You're on the list! Check your inbox.", '¡Estás en la lista! Revisa tu correo.')}
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={L('Your email address', 'Tu correo electrónico')}
              className="flex-1 h-14 px-4 border-2 border-black font-bold text-neutral-900 placeholder-neutral-400 focus:outline-none focus:ring-4 focus:ring-black/20"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="h-14 px-8 bg-black text-white font-black uppercase tracking-wider border-2 border-black shadow-[4px_4px_0px_rgba(255,255,255,0.4)] hover:-translate-y-0.5 active:translate-y-0 transition-transform flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="newsletter-submit-btn"
            >
              <PaperPlaneTilt size={18} weight="fill" />
              {status === 'loading' ? L('Subscribing…', 'Suscribiendo…') : L('Subscribe', 'Suscribirme')}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="mt-3 text-white font-bold text-sm bg-black/30 inline-block px-3 py-1" data-testid="newsletter-error">{error}</p>
        )}
      </div>
    </div>
  );
};

export default NewsletterSignup;
